import { getApiBaseUrl } from '../../utils/apiBaseUrl';

export const getAboutContent = async (): Promise<{
  aboutContent: string;
  aboutHeading: string;
}> => {
  try {
    const baseUrl = getApiBaseUrl();
    const response = await fetch(`${baseUrl}/api/About`);
    if (!response.ok) {
      throw new Error(`Failed to fetch about content: ${response.status}`);
    }

    const data = await response.json();

    if (data.aboutContent && data.aboutHeading) {
      return { aboutContent: data.aboutContent, aboutHeading: data.aboutHeading };
    } else {
      throw new Error("Content or heading field is missing in the response");
    }
  } catch (error) {
    // console.error("Error fetching about content:", error);
    throw error;
  }
};
